export var UserTrackingFlow;
(function (UserTrackingFlow) {
    UserTrackingFlow["CAREER_SITES"] = "CAREER_SITES";
    UserTrackingFlow["OFFCAP"] = "OFFCAP";
})(UserTrackingFlow || (UserTrackingFlow = {}));
